<template>
  <div class="card mb-25 border-0 rounded-0 bg-white add-user-card">
  <div class="card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing">
          <Form ref="mediaForm" @submit="editMedia" :validation-schema="mediaSchema" :initial-values="mediaForm">
          <div class="row">
            <div class="col-md-6">
              <div class="form-group mb-15 mb-sm-20 mb-md-25">
                <label class="d-block text-black fw-semibold mb-10">
                  Titre <span class="text-danger">*</span>
                </label>
                <Field name="titre" type="text" 
                class="form-control shadow-none fs-md-15 text-black" placeholder="Entrer le titre"/>
                <ErrorMessage name="titre" class="text-danger"/>
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group mb-15 mb-sm-20 mb-md-25">
                <label class="d-block text-black fw-semibold mb-10">
                  Type de media <span class="text-danger">*</span>
                </label>
                <Field  name="typeMedia"  v-slot="{ field }">
                  <Multiselect
                  v-model="field.value"
                  v-bind="field"
                  placeholder="Rechercher un type de media"
                  :filter-results="false"
                  :min-chars="3"
                  :resolve-on-load="false"
                  :delay="0"
                  :searchable="true"
                  :options-limit="300"
                  noResultText= "Aucun enregistrement trouvé"
                  noOptionsText="Tapez au moins trois caractères"
                  />
                </Field>  
                <ErrorMessage name="typeMedia" class="text-danger"/>
              </div>
            </div>
            <div class="col-md-12">
                <div class="form-group mb-15 mb-sm-20 mb-md-25">
                  <label class="d-block text-black fw-semibold mb-10">
                    Description
                  </label>
                  <Field name="description" as="textarea"  cols="30"
                    rows="12" placeholder="Ecrire votre message" v-slot="{ field}" class="form-control shadow-none rounded-0 text-black">
                  <textarea
                  class="form-control shadow-none rounded-0 text-black"
                    v-model="field.value"
                  ></textarea>
                </Field>
                <ErrorMessage name="description" class="text-danger"/>
                </div>
              </div>
            <div class="col-md-12">
              <div class="form-group mb-15 mb-sm-20 mb-md-25">
                <label class="d-block text-black fw-semibold mb-10">
                  Article <span class="text-danger">*</span>
                </label>
                <Field  name="article"  v-slot="{ field }">
                  <Multiselect
                    v-model="field.value"
                    v-bind="field"
                    placeholder="Rechercher un article"
                    :filter-results="false"
                    :min-chars="3"
                    :resolve-on-load="false"
                    :delay="0"
                    :searchable="true"
                    :options-limit="300"
                    noResultText= "Aucun enregistrement trouvé"
                    noOptionsText="Tapez au moins trois caractères"
                  />
                </Field>  
                <ErrorMessage name="article" class="text-danger"/>
              </div>
            </div>
        <div class="col-md-12">
          <div class="d-flex align-items-center ">
            <button
              class="default-btn me-20 transition border-0 fw-medium text-white pt-10 pb-10 ps-25 pe-25 pt-md-11 pb-md-11 ps-md-35 pe-md-35 rounded-1 fs-md-15 fs-lg-16 bg-success"
              type="submit"
            >
                Modifier un media
            </button>
            <router-link to="/liste-medias" 
                class=" btn btn-danger transition border-0 lh-1 fw-medium"><i class="flaticon-delete lh-1 me-1 position-relative top-2"></i>
                <span class="position-relative"></span>Annuler</router-link>
          </div>
        </div>
      </div>
    </Form>
  </div>
</div>
</template>

<script lang="ts">

import { defineComponent, ref, onMounted } from 'vue';
import { Form, Field, ErrorMessage } from 'vee-validate';
import { error, success } from '@/utils/utils';
import { useRoute, useRouter } from 'vue-router';
import ApiService from '@/services/ApiService';
import { Media} from '@/models/Media';
import * as Yup from 'yup';
import axios from 'axios';
import Multiselect from '@vueform/multiselect'


export default defineComponent({
    name: "EditMedia",
    components: {
    Form,
    Field,
    ErrorMessage,
    Multiselect
  },
  setup: () => {
    const mediaSchema = Yup.object().shape({
      titre: Yup.string().required('Le titre est obligatoire'),
      description: Yup.string().notRequired(),
      article: Yup.string().required('L\'article est obligatoire'),
      typeMedia: Yup.string().required('Le type de media est obligatoire'),
    });

    const mediaForm = ref<Media>();
    //const abonnementOptions = ref([]);
    const router = useRouter();
    const route = useRoute();
    //const casierOptions = ref([]);

    function getMedia(id:number) {
      ApiService.get("/medias/"+id.toString())
        .then(({ data }) => {
          for (const key in data.data) {
            mediaForm.value?.setFieldValue(key, 
            (typeof data.data[key] === 'object' && data.data[key] !== null)? data.data[key].id :data.data[key]
          );
          }
      })
      .catch(({ response }) => {
        error(response.data.message);
      });
    }

    const editMedia = async (values, {resetForm}) => {
      // const data = mediaForm.value;
      // ApiService.put("/colis/" + data?.id, data)
      //   .then(({ data }) => {
      //     if (data.code == 200) {
      //       success(data.message);
      //       resetForm();
      //       router.push({ name: "ListeMediaPage" });
      //     }
      //   }).catch(({ response }) => {
      //     error(response.data.message);
      //   });
    };

    const fetchCasiers = async () => {
      // ApiService.get("/casiers")
      // .then(({ data }) => {
      //   const donnees = data.data.data;
      //   casierOptions.value = donnees.map((casier) => {
      //     return {
      //       label: `${casier.code} - ${casier.etagere.code}`,
      //       value: casier.id,
      //     }
      //   });
      // })
      // .catch(({ response }) => {
      //   error(response.data.message)
      // });
    }

    const fetchAbonnements = async () => {
      // ApiService.get("/abonnements")
      // .then(({ data }) => {
      //   const donnees = data.data.data;
      //   abonnementOptions.value = donnees.map((abonnement) => {
      //     return {
      //       value: abonnement.id,
      //     label: `${abonnement.refAbo} - [${abonnement.abonne?.nomComplet}]`,
      //     }
      //   });
      // })
      // .catch(({ response }) => {
      //   error(response.data.message)
      // });
    }

    onMounted(() => {
      // fetchAbonnements();
      // fetchCasiers();
      if(route.params.id) {
        getMedia(parseInt(route.params.id as string));
      }
    });

    return { 
      mediaSchema, editMedia, mediaForm
    };
  },
});
</script>